import React from "react";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import useDialog from "hooks/useDialog";
import { useNavigate } from "react-router";

const TrialExpiredDialog = () => {
  const { isTrialExpiredDialogOpen, closeTrialExpiredDialog } = useDialog();
  const navigate = useNavigate();

  // Mark dialog as shown when closed
  const markDialogAsShown = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const shownUsers = JSON.parse(
          localStorage.getItem("trial_expired_dialog_shown") || "[]"
        );
        if (!shownUsers.includes(user.uid)) {
          shownUsers.push(user.uid);
          localStorage.setItem(
            "trial_expired_dialog_shown",
            JSON.stringify(shownUsers)
          );
        }
      }
    } catch (error) {
      console.error("Error marking trial expired dialog as shown:", error);
    }
  };

  const handleUpgrade = async () => {
    markDialogAsShown();
    closeTrialExpiredDialog();
    navigate("/");
    setTimeout(() => {
      const signInFeeSection = document.querySelector("#sign-in-fee-section");
      if (signInFeeSection) {
        signInFeeSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Delay to ensure the home page has loaded
  };

  const handleCancel = async () => {
    markDialogAsShown();
    closeTrialExpiredDialog();
  };

  return (
    <AnimatedDialogLayout
      isOpen={isTrialExpiredDialogOpen}
      onClose={handleCancel}
    >
      <div className="max-w-lg w-full sm:w-[500px] text-center py-6">
        {/* Warning Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-r from-orange-400 to-red-500 rounded-full flex items-center justify-center">
            <span className="text-3xl">⏰</span>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-black font-bold text-[24px] mb-4 leading-[30px]">
          Prova del piano Pro finita
        </h1>

        {/* Description */}
        <p className="text-[#1A1A1A] text-[16px] font-normal leading-[22px] mb-8">
          La tua prova gratuita di 15 giorni del piano Pro è esaurita, rimani un
          utente pro a partire da 9,90€ al mese!
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={handleCancel}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-[11px] h-[51px] px-8 font-semibold text-[16px] transition-all duration-300 ease-in-out order-2 sm:order-1"
          >
            Annulla
          </button>

          <button
            onClick={handleUpgrade}
            className="bg-primary hover:bg-opacity-90 text-white rounded-[11px] h-[51px] px-8 font-semibold text-[16px] transition-all duration-300 ease-in-out order-1 sm:order-2"
          >
            Upgrade
          </button>
        </div>
      </div>
    </AnimatedDialogLayout>
  );
};

export default TrialExpiredDialog;
